/* eslint-disable import/prefer-default-export */
import { ColorSystemNegative1 } from 'autogen/design-tokens/tokens';
import styled from 'styled-components';

export const ErrorMessage = styled.span`
    color: ${ColorSystemNegative1};
`;
